<template>
    <main class="stats">
        <section class="list-banner">
            <div class="overlay"></div>
            <h1 class="banner-title">Countries</h1>
        </section>
        <SubMenu parent-route-name="stats" />
        <LoadingScreen v-if="!loaded" message="Loading country statistics…" />
        <section v-else class="max-width-container">
            <article>
                <h2>Visited countries</h2>
                <DataTable v-if="loaded" :table="table" />
                <MetricRegionMap :entries="map" :metrics="metrics" />
            </article>
        </section>
        <section class="actions">
            <router-link to="/stats">
                <Bttn class="outlined">Back</Bttn>
            </router-link>
        </section>
    </main>
</template>
<script>
import DataTable from "js/components/tables/DataTable";
import MetricRegionMap from "js/components/blocks/MetricRegionMap";
import LoadingScreen from "js/components/common/LoadingScreen";
import { fetch } from "js/lib/server.js";

const YEARS_AGO = (value) => (value === 0 ? "< 1 yr ago" : `${-value} yr ago`);
export default {
    components: {
        LoadingScreen,
        DataTable,
        MetricRegionMap,
    },
    data() {
        return {
            loaded: false,
            table: {},
            map: [],
            metrics: [
                { key: "trips", label: "Most trips", unit: ["trip", "trips"] },
                {
                    key: "nights",
                    label: "Most nights",
                    unit: ["night", "nights"],
                },
                { key: "days", label: "Most days", unit: ["day", "days"] },
                {
                    key: "years",
                    label: "Most recent visit",
                    format: YEARS_AGO,
                    legend: {
                        format: (value) => (value === 0 ? "<1" : `${-value}`),
                        caption: "years ago",
                        inverted: true,
                    },
                    tooltip: (value) => `last visit ${YEARS_AGO(value)}`,
                },
            ],
        };
    },
    mounted() {
        fetch("/api/stats/countries").then((response) => {
            this.table = response.data.table;
            this.map = response.data.maps.countries;
            this.loaded = true;
        });
    },
};
</script>
